"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useKeyDashboardCollageAll = void 0;
exports.dashboardCollageAllSetMock = dashboardCollageAllSetMock;
exports.dashboardCollageAll = dashboardCollageAll;
exports.useQueryDashboardCollageAll = useQueryDashboardCollageAll;
exports.useInfiniteQueryDashboardCollageAll = useInfiniteQueryDashboardCollageAll;
const gateway_core_1 = require("@ifit/gateway-core");
const is_down_1 = require("./is-down");
let setMock;
let reactQuery;
function dashboardCollageAllSetMock(mock) {
    setMock = mock;
}
async function dashboardCollageAll(params) {
    if (!params) {
        params = {};
    }
    if (setMock) {
        return setMock(params);
    }
    const client = params.client || (0, gateway_core_1.getDefaultClient)();
    if (!client) {
        throw new Error('No @ifit/gateway-core GatewayApiClient has been constructed yet! Please do so before calling gateway methods, or pass a compatible client in the parameters.');
    }
    const requestURL = `/wolf-dashboard-service/v1/dashboard/collage`;
    const requestConfig = params.useM2MAuth
        ? await client.getM2MRequestConfig(params)
        : client.getRequestConfig(params);
    const headers = Object.assign(Object.assign({}, requestConfig.headers), params.headers);
    const queryParams = Object.assign({}, requestConfig.params);
    queryParams.dashboardContentId = params.dashboardContentId;
    queryParams.userType = params.userType;
    queryParams.date = params.date;
    queryParams.startingDate = params.startingDate;
    queryParams.endingDate = params.endingDate;
    queryParams.page = params.page;
    queryParams.perPage = params.perPage;
    if ((client.statusChecksEnabled || params.forceStatusCheck) && (await (0, is_down_1.wolfDashboardServiceIsDown)(client))) {
        return null;
    }
    const response = await client.req.send(requestURL, Object.assign(Object.assign({}, requestConfig), { headers, method: 'GET', params: queryParams }), params);
    return params.returnResponse
        ? response
        : response.data;
}
exports.useKeyDashboardCollageAll = 'wolf-dashboard-service:dashboardCollageAll:get';
function useQueryDashboardCollageAll(requestParams, queryOptions) {
    if (!reactQuery) {
        reactQuery = require('react-query');
    }
    const key = [exports.useKeyDashboardCollageAll, requestParams];
    return reactQuery.useQuery(key, queryFn, queryOptions);
}
function useInfiniteQueryDashboardCollageAll(requestParams, queryOptions) {
    if (!reactQuery) {
        reactQuery = require('react-query');
    }
    const key = [exports.useKeyDashboardCollageAll, requestParams];
    return reactQuery.useInfiniteQuery(key, queryFn, queryOptions);
}
function queryFn({ queryKey, pageParam }) {
    const [, params] = queryKey;
    const promise = dashboardCollageAll(pageParam ? Object.assign(Object.assign({}, params), pageParam) : params);
    if (params === null || params === void 0 ? void 0 : params.cancelSource) {
        promise.cancel = () => {
            params.cancelSource.cancel('Query was cancelled by React Query');
        };
    }
    return promise;
}
//# sourceMappingURL=dashboard-collage-all.js.map